﻿import {SigniflowOfficeApp} from "./SigniflowOfficeApp";
import i18next from 'i18next';
import loci18next from "loc-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import Swal from "sweetalert2";
import * as Sentry from "@sentry/browser";
import HostType = Office.HostType;
import {BrowserTracing} from "@sentry/tracing";
import {bs4Toast} from "./bs4-toast";
import {browserTracingIntegration} from "@sentry/browser";


const VERSION_NUMBER = "cd49d12158df64d042d47c9e22a5f0582e76dd84";

$(async function () {

    Sentry.init({
        dsn: "https://42e8a2941a0947a1bd4fb3671884ef8a@o1395240.ingest.sentry.io/6718094",
        integrations: [browserTracingIntegration()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.2,
        // tracesSampleRate: 1.0,
        release: `signiflow-office-addins@${VERSION_NUMBER}`,
    });

    let officeApp = new SigniflowOfficeApp();
    let loginDialog;
    let issueToastIgnore = false;

    let loginForm = $('#loginForm');
    let emailForm = $('#emailForm');
    let serverSelectionForm = $('#serverSelectionForm');
    let loginButtonForm = $('#loginButtonForm');
    let passwordForm = $('#passwordForm');
    let uploadButton = $('#uploadButton');
    let uploadItems = $('.uploadItem');
    let adLoginButton = $('#adLogin');
    let adSamlLoginButton = $('#adSamlLogin');
    let oneLoginButton = $('#oneLogin');
    let loginButton = $('#loginButton');
    let serverFetchLoader = $('#serverFetchLoader');
    let loginLoader = $('#loginLoader');
    let uploadLoader = $('#uploadLoader');
    let fileselection = $('#file-selection');
    let fileselector = $('#file-selector');
    let nofilewarning = $('#nofilewarning');
    let logoutButton = $('#logoutButton');
    let logoutLink = $('#logoutLink');
    let topBarDiv = $('#topBarDiv');
    let versionNumber = $('.versionNumber');
    let serverIdentifier = $('#serverIdentifier');
    let resetPassLink = $('#resetPassLink');
    let emailConfirmButton = $('#emailConfirmButton');
    let serverSelectButton = $('#serverSelectButton');
    let serverBackButton = $('#serverBackButton');
    let loginBackButton = $('#loginBackButton');
    let loginLaunchButton = $('#loginLaunchButton');
    let freCarousel = $('#freCarousel');
    let freSkipButton = $('#freSkip');
    let freFinishButton = $('#freFinish');
    let flatPeopleContainer = $('#flatPeopleContainer');
    let initLoader = $('#initLoader');

    initLoader.show();
    freCarousel.hide();
    flatPeopleContainer.hide();
    loginForm.hide()
    emailForm.show();
    serverSelectionForm.hide();
    loginButtonForm.hide();
    loginLoader.hide();
    serverFetchLoader.hide();
    uploadLoader.hide();
    uploadItems.hide();
    fileselection.hide();
    nofilewarning.hide();
    adLoginButton.hide();

    // Disable the login button and associated controls until Office loads
    emailConfirmButton.attr('disabled', 'disabled');
    serverSelectButton.attr('disabled', 'disabled');
    loginButton.attr('disabled', 'disabled');
    serverBackButton.attr('disabled', 'disabled');
    loginBackButton.attr('disabled', 'disabled');
    logoutButton.attr('disabled', 'disabled');
    logoutLink.attr('disabled', 'disabled');

    setTimeout(() => {
        if (!officeApp.officeSdkReady) {
            Sentry.captureMessage("Office SDK not loaded", "warning");
            Swal.fire({
                icon: "error",
                text: i18next.t('text.officeSdkNotLoaded'),
                showDenyButton: false,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: i18next.t('button.reload'),
                allowOutsideClick: true
            }).then((result) => {
                if (result.value) {
                    location.reload();
                }
            });
        }
    }, 15000);

    let acceptedFileTypes = [
        "application/pdf",
        "application/vnd.ms-excel",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/msword",
        "application/xml",
        "image/png",
        "image/jpeg",
        "image/gif"
    ]

    // @ts-ignore
    await i18next.use(LanguageDetector).use(HttpApi).init({
        nonExplicitSupportedLngs: true,
        load: "all",
        fallbackLng: 'dev',
        preload: ['en'],
        lowerCaseLng: true,
        detection: {
            // order and from where user language should be detected
            // order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],

            // keys or params to lookup language from
            lookupQuerystring: 'lng',
            lookupCookie: 'i18next',
            lookupLocalStorage: 'i18nextLng',
            lookupSessionStorage: 'i18nextLng',

            // cache user language on
            caches: ['localStorage', 'cookie'],

            // optional htmlTag with lang attribute, the default is:
            htmlTag: document.documentElement,

            // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
            cookieOptions: {path: '/', sameSite: 'strict'}
        },
        backend: {
            // path where resources get loaded from, or a function
            // returning a path:
            // function(lngs, namespaces) { return customPath; }
            // the returned path will interpolate lng, ns if provided like giving a static path
            //
            // If allowMultiLoading is false, lngs and namespaces will have only one element each,
            // If allowMultiLoading is true, lngs and namespaces can have multiple elements
            loadPath: window.location.origin + '/locales/Resources.{{lng}}.json',

            // your backend server supports multiloading
            // /locales/resources.json?lng=de+en&ns=ns1+ns2
            // Adapter is needed to enable MultiLoading https://github.com/i18next/i18next-multiload-backend-adapter
            // Returned JSON structure in this case is
            // {
            //  lang : {
            //   namespaceA: {},
            //   namespaceB: {},
            //   ...etc
            //  }
            // }
            allowMultiLoading: false, // set loadPath: '/locales/resources.json?lng={{lng}}&ns={{ns}}' to adapt to multiLoading

            // allow cross domain requests
            crossDomain: true,

            // allow credentials on cross domain requests
            withCredentials: false,

            // overrideMimeType sets request.overrideMimeType("application/json")
            overrideMimeType: false,

            reloadInterval: false // can be used to reload resources in a specific interval (useful in server environments)
        }
    });

    const localize = loci18next.init(i18next, {
        selectorAttr: 'data-i18n', // selector for translating elements
        targetAttr: 'i18n-target',
        optionsAttr: 'i18n-options',
        useOptionsAttr: false,
        parseDefaultValueFromContent: true
    });

    localize("#mainContent");

    versionNumber.text(`v-${VERSION_NUMBER.substring(0,8)}`);

    function queueIssueToast(persistent: boolean = false) {
        issueToastIgnore = false;
        setTimeout(async () => {
            if (issueToastIgnore) {
                return;
            }
            bs4Toast.show(i18next.t('text.havingproblems', 'Having problems?'), '', {
                delay: persistent ? 0 : 5000,
                autohide: !persistent,
                headerClasses: ['toast-bg-dark'],
                bodyClasses: ['toast-body-white'],
                buttons: [
                    {
                        text: i18next.t('button.reloadaddin', 'Reload Add-in'),
                        class: 'btn btn-info btn-sm width-available',
                        callback: () => {
                            location.reload();
                        }
                    },
                    {
                        text: i18next.t('button.contactsupport', 'Contact Support'),
                        class: 'btn btn-outline-info btn-sm width-available',
                        callback: async () => {
                            var eventId = Sentry.captureMessage("Issue reported");
                            await Swal.fire({
                                icon: "info",
                                showDenyButton: false,
                                showCancelButton: false,
                                showConfirmButton: false,
                                titleText: i18next.t("title.errorreported", "Error Reported"),
                                text: i18next.t("text.contactsupportevent", {eventId: eventId})
                            })
                        }
                    }
                ]
            })
        }, 15000);
    }

    //region Login Stuffs
    async function logout() {
        officeApp.debugLog("Logging Out");
        freCarousel.hide();
        flatPeopleContainer.show();
        loginForm.show();
        emailForm.show();
        serverSelectionForm.hide();
        loginButtonForm.hide();
        uploadItems.hide();
        loginLoader.hide();
        uploadLoader.hide();
        fileselection.hide();
        nofilewarning.hide();
        topBarDiv.hide();
        $("#serverUrlInput").val("");
        $('#password').val("");
        $('#passwordFormEmail').val("");
        serverIdentifier.text("");
        resetPassLink.attr("href", "");
        await officeApp.logout();
    }

    logoutButton.on("click", async ev => {
        ev.preventDefault();
        await logout();
    });

    logoutLink.on("click", async ev => {
        ev.preventDefault();
        await logout();
    });

    resetPassLink.on("click", async ev => {
        await logout();
    });

    loginBackButton.on("click", async ev => {
        ev.preventDefault();
        await logout();
    });

    serverBackButton.on("click", async ev => {
        ev.preventDefault();
        await logout();
    });

    freSkipButton.on("click", async ev => {
        ev.preventDefault();
        await logout();
    });

    freFinishButton.on("click", async ev => {
        ev.preventDefault();
        await logout();
    });

    emailForm.on("submit", async ev => {
        ev.preventDefault();
        let email = $('#email').val().toString();
        if (!email) {
            return;
        }// Do nothing if email is empty
        $('#passwordFormEmail').val(email);
        emailForm.hide();
        serverSelectionForm.show();
    });

    serverSelectionForm.on("submit", async ev => {
        ev.preventDefault();
        let urlInput = $('#serverUrlInput').val().toString();

        function validateAndCleanUrl(url: string): string | null {
            if (!url || url.trim() === "") {
                bs4Toast.show("Error", "Server address cannot be empty.", {
                    delay: 3000,
                    autohide: true,
                    headerClasses: ['toast-bg-danger']
                });
                return null;
            }

            let cleanedUrl = url.trim();
            if (!cleanedUrl.startsWith("https://") && !cleanedUrl.startsWith("http://")) {
                cleanedUrl = "https://" + cleanedUrl;
            } else if (cleanedUrl.startsWith("http://")) {
                cleanedUrl = cleanedUrl.replace("http://", "https://");
            }
            let removeTrailingSlash = true;
            while (removeTrailingSlash) {
                if (cleanedUrl.endsWith("/")) {
                    cleanedUrl = cleanedUrl.slice(0, -1);
                }
                else {
                    removeTrailingSlash = false;
                }
            }
            try {
                new URL(cleanedUrl);
            }
            catch (_) {
                bs4Toast.show("Error", "Invalid server address format.", {
                    delay: 3000,
                    autohide: true,
                    headerClasses: ['toast-bg-danger']
                });
                return null;
            }
            return cleanedUrl;
        }

        let validatedUrl = validateAndCleanUrl(urlInput);

        if (!validatedUrl) {
            return;
        }

        officeApp.signiflowUrl = validatedUrl;
        serverSelectionForm.hide();
        serverFetchLoader.show();
        await setupLoginForm();
        issueToastIgnore = true;
        serverFetchLoader.hide();
        loginButtonForm.show();
    });

    loginLaunchButton.on("click", async ev => {
        ev.preventDefault();
        await attemptLogin();
    });

    passwordForm.on("submit", async ev => {
        ev.preventDefault();
        passwordForm.hide();
        loginLoader.show();
        let email = $('#passwordFormEmail').val().toString();
        let password = $('#password').val().toString();
        let signiFlowUrl = $('#signiflowUrl').val().toString();
        officeApp.signiflowUrl = signiFlowUrl;
        let result = await officeApp.login(email, password);
        if (result == true) {
            Office.context.ui.messageParent("auth_success");
        } else {
            Office.context.ui.messageParent("auth_failed");
            passwordForm.show();
            loginLoader.hide();
            await Swal.fire({
                icon: "error",
                showDenyButton: false,
                showCancelButton: false,
                showConfirmButton: false,
                titleText: "Login Failed",
                text: "Please ensure your details are correct"
            })
        }
    });

    async function processLoginMessage(message) {
        officeApp.debugLog(`processLoginMessage: ${JSON.stringify(message)}`);
        if (message.message == "auth_success") {
            if (document.hasStorageAccess) {
                officeApp.debugLog("document has storage access API");
                document.hasStorageAccess().then(async function (hasStorageAccess) {
                    if (!hasStorageAccess) {
                        officeApp.debugLog("document does not have storage access");
                        await Swal.fire({
                            icon: "warning",
                            showConfirmButton: true,
                            showDenyButton: true,
                            titleText: "Storage Access Required",
                            text: "Signiflow requires access to your storage to store your credentials. Please grant access to Signiflow.",
                            confirmButtonText: "Grant Access",
                            denyButtonText: "Cancel",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(async function (result) {
                            if (result.isConfirmed) {
                                officeApp.debugLog("storage access granted by user");
                                await document.requestStorageAccess().then(async function () {
                                    officeApp.debugLog("storage access granted by browser");
                                    loginDialog.close();
                                    await checkCookie();
                                }).catch(function (reason) {
                                    officeApp.debugLog("storage access denied by browser");
                                    Sentry.addBreadcrumb({
                                        category: "Storage",
                                        message: "Storage access denied",
                                        level: "warning"
                                    });
                                    let issueId = Sentry.captureException(reason ?? new Error("Storage access denied"));
                                    Swal.fire({
                                        icon: "error",
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        titleText: "Storage Access Denied",
                                        text: `Permission denied, please try again or contact support\nEvent ID: ${issueId}`
                                    });
                                });
                            } else {
                                officeApp.debugLog("storage access denied by user");
                                await logout();
                                loginDialog.close();
                            }
                        });
                    } else {
                        officeApp.debugLog("document has storage access, checking cookie");
                        await checkCookie();
                        loginDialog.close();
                    }
                });
            } else {
                officeApp.debugLog("document does not have storage access API");
                await checkCookie();
                loginDialog.close();
            }
        }
    }

    async function attemptLogin() {
        loginButtonForm.hide();
        loginLoader.show();

        let email = $('#email').val().toString();
        Office.context.ui.displayDialogAsync(`${window.location.origin}/Auth/Login?sfUrl=${encodeURIComponent(officeApp.signiflowUrl)}&email=${encodeURIComponent(email)}`,
            {height: 60, width: 30}, function (result) {
                officeApp.debugLog("Login Dialog has initialized. Wiring up events");
                loginDialog = result.value;
                loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLoginMessage);
                loginDialog.addEventHandler(Office.EventType.DialogEventReceived, async function (result) {
                    officeApp.debugLog(`Login Dialog event received: ${JSON.stringify(result)}`);
                    loginDialog.close()
                    await logout();
                });
            });
    }

    async function checkCookie() {
        if (window.location.href.indexOf("Login") !== -1) {
            // We're on the login page, don't try to log in here
            return;
        } else {
            if (await officeApp.cookieExists()) {
                freCarousel.hide();
                loginForm.hide();
                loginLoader.show();
                if (await officeApp.validateCookie()) {
                    await loginSuccess();
                } else {
                    loginForm.show();
                    uploadItems.hide();
                    loginLoader.hide();
                    await logout();
                }
            } else {
                officeApp.userLog("No cookie found");
            }
        }
    }

    async function setupLoginForm() {
        serverIdentifier.text(officeApp.signiflowUrl.replace(/^https?:\/\//, ''));
        resetPassLink.attr("href", `${officeApp.signiflowUrl}/Forgot.aspx`);
        await showAD();
    }

    async function showAD() {
        try {
            let availableLoginOptions = await officeApp.getAvailableLoginOptions();
            
            if (availableLoginOptions.find((option) => option.OptionName === 'AAD')){
                adLoginButton.show();
            }else{
                adLoginButton.hide();
            }

            if (availableLoginOptions.find((option) => option.OptionName === 'OneLogin')) {
                oneLoginButton.show();
                oneLoginButton.data("option-id", availableLoginOptions.find((option) => option.OptionName === 'OneLogin').OptionId)
            }else{
                oneLoginButton.hide();
            }

            if (availableLoginOptions.find((option) => option.OptionName === 'Azure')) {
                adSamlLoginButton.show();
                adSamlLoginButton.data("option-id", availableLoginOptions.find((option) => option.OptionName === 'Azure').OptionId)
            }else{
                adSamlLoginButton.hide();
            }
        } catch (e) {
            officeApp.userLog("Unable to retrieve server settings, fallback to standard login");
            Sentry.addBreadcrumb({
                category: "auth",
                message: "Unable to retrieve server settings, fallback to standard login",
                level: "warning"
            });
            Sentry.captureException(e)
        }
    }

    async function processAdMessage(dialogMessage) {
        let message = dialogMessage.message;
        if (message == 'auth_failed') {
            logout();
            Swal.fire({
                icon: "error",
                showDenyButton: false,
                showCancelButton: false,
                showConfirmButton: false,
                titleText: "Login Failed",
                text: "Please ensure your details are correct"
            })
        } else if (message) {
            if (document.hasStorageAccess) {
                document.hasStorageAccess().then(async function (hasStorageAccess) {
                    if (!hasStorageAccess) {
                        document.requestStorageAccess().then(async function () {
                            await checkCookie();
                            loginDialog.close();
                        }).catch(function () {
                            // User must have previously interacted with this domain loaded in a top frame
                            // Also you should have previously written a cookie when domain was loaded in the top frame
                            Sentry.addBreadcrumb({
                                category: "auth",
                                message: "AD Message processed, storage denied",
                                level: "log",
                                data: {
                                    message: message
                                }
                            });
                            let issueId = Sentry.captureMessage("AD Message processed, storage denied");
                            Swal.fire({
                                icon: "error",
                                showDenyButton: false,
                                showCancelButton: false,
                                showConfirmButton: false,
                                titleText: "Login Failed",
                                text: `Permission denied, please try again or contact support\nEvent ID: ${issueId}`
                            })
                            loginDialog.close();
                        });
                    } else {
                        await checkCookie();
                        loginDialog.close();
                    }
                });
            } else {
                await checkCookie();
                loginDialog.close();
            }
        }
    }

    adLoginButton.on("click", async ev => {
        ev.preventDefault();
        loginForm.hide();
        loginLoader.show();
        Office.context.ui.displayDialogAsync(`${window.location.origin}/Auth/LoginWithAzureAd?sfUrl=${encodeURIComponent(officeApp.signiflowUrl)}`,
            {height: 60, width: 30}, function (result) {
                console.log("AD Dialog has initialized. Wiring up events");
                loginDialog = result.value;
                loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processAdMessage);
                loginDialog.addEventHandler(Office.EventType.DialogEventReceived, async function (result) {
                    loginDialog.close();
                    await logout();
                });
            });
    });

    oneLoginButton.on("click", async ev => {
        ev.preventDefault();
        loginForm.hide();
        loginLoader.show();
        Office.context.ui.displayDialogAsync(`${window.location.origin}/Auth/LoginWithSaml?sfUrl=${encodeURIComponent(officeApp.signiflowUrl)}&providerId=${oneLoginButton.data('option-id')}`,
            {height: 60, width: 30}, function (result) {
                console.log("SAML Dialog has initialized. Wiring up events");
                loginDialog = result.value;
                loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processAdMessage);
                loginDialog.addEventHandler(Office.EventType.DialogEventReceived, async function (result) {
                    loginDialog.close();
                    await logout();
                });
            });
    });

    adSamlLoginButton.on("click", async ev => {
        ev.preventDefault();
        loginForm.hide();
        loginLoader.show();
        Office.context.ui.displayDialogAsync(`${window.location.origin}/Auth/LoginWithSaml?sfUrl=${encodeURIComponent(officeApp.signiflowUrl)}&providerId=${adSamlLoginButton.data('option-id')}`,
            {height: 60, width: 30}, function (result) {
                console.log("SAML Dialog has initialized. Wiring up events");
                loginDialog = result.value;
                loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processAdMessage);
                loginDialog.addEventHandler(Office.EventType.DialogEventReceived, async function (result) {
                    loginDialog.close();
                    await logout();
                });
            });
    });

    //endregion

    await Office.onReady(async info => {
        officeApp.officeSdkReady = true;
        officeApp.debugLog("Office SDK Ready")
        await officeApp.init(info.host);

        // Apply dev language on dev server
        if (window.location.origin.includes("dev.office365.signiflow.com") ||
            window.location.origin.includes("localhost") ||
            window.location.origin.includes("127.0.0.1")) {
            i18next.changeLanguage('dev').then(() => {
                localize("#mainContent");
            });
            queueIssueToast(true);
        } else {
            let language = Office.context.displayLanguage;
            officeApp.debugLog("office language: " + language)
            i18next.changeLanguage(language).then(() => {
                localize("#mainContent");
            });
        }

        //reenable the login controls
        emailConfirmButton.removeAttr("disabled");
        serverSelectButton.removeAttr("disabled");
        loginButton.removeAttr("disabled");
        serverBackButton.removeAttr("disabled");
        loginBackButton.removeAttr("disabled");
        logoutButton.removeAttr("disabled");
        logoutLink.removeAttr("disabled");
        if (await officeApp.cookieExists()) {
            initLoader.hide();
            topBarDiv.hide();
        } else {
            initLoader.hide();
            topBarDiv.hide();
            freCarousel.show();
        }
        await checkCookie();
    })

    uploadButton.on("click", async e => {
        officeApp._resetPage = function (success) {
            uploadItems.show();
            uploadLoader.hide();
            if (officeApp.host == HostType.Outlook) {
                if (Office.context.mailbox.item.attachments.filter(value => value.isInline == false && acceptedFileTypes.includes(value.contentType)).length > 1) {
                    fileselection.show();
                }
            }

            if (success) {
                Swal.fire({
                    icon: "success",
                    text: i18next.t('text.uploadsuccess'),
                    showDenyButton: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    allowOutsideClick: true
                })
            }
        }
        uploadItems.hide();
        fileselection.hide();
        uploadLoader.show();
        if (officeApp.host == HostType.Outlook) {
            if (Office.context.mailbox.item.attachments.filter(value => value.isInline == false && acceptedFileTypes.includes(value.contentType)).length > 1) {
                await officeApp.uploadDocument(fileselector.val().toString())
            } else {
                await officeApp.uploadDocument();
            }
        } else {
            await officeApp.uploadDocument();
        }
    });

    async function loginSuccess() {
        freCarousel.hide();
        loginForm.hide();
        loginLoader.hide();
        uploadItems.show();
        topBarDiv.show();
        logoutButton.attr("src", await officeApp.getGravatar())
        serverIdentifier.text(officeApp.signiflowUrl.replace(/^https?:\/\//, ''));
        officeApp.debugLog("Logged in");

        if (officeApp.host == HostType.Outlook) {
            officeApp.debugLog(Office.context.mailbox.item.attachments);
            let attachments = Office.context.mailbox.item.attachments.filter(value => value.isInline == false && acceptedFileTypes.includes(value.contentType));
            officeApp.debugLog(attachments);
            officeApp.debugLog(attachments.length + ' attachments found');
            if (attachments.length == 1) {
                loginForm.hide();
                loginLoader.hide();
                fileselection.hide();
                nofilewarning.hide();
                uploadItems.show();
            } else if (attachments.length > 1) {
                fileselection.show();
                for (let attachment of attachments) {
                    fileselector.append($("<option/>", {
                        value: attachment.name, text: attachment.name
                    }));
                }
            } else {
                uploadItems.hide();
                nofilewarning.show();
            }
        }
    }
})
